export type ApiUserConsent = 'theming' | 'contentcard' | 'ebikespecsheet';
export type FetchingQueueCallback = [() => void, (error: Error) => void];

let inProgress = false;
let queue: Array<FetchingQueueCallback> = [];

let grantedConsents: ApiUserConsent[];
let pendingConsents: ApiUserConsent[];

const resetFetchQueue = () => {
  queue = [];
  inProgress = false;
}

const fetchConsents = (): Promise<void> => new Promise((resolve, reject) => {
  if (inProgress) {
    queue.push([resolve, reject]);
    return;
  }
  inProgress = true;

  fetch('/api/consents')
    .then((result) => {
      if (!result.ok) {
        result.text()
          .then((errorText) => {
            console.error('Could not fetch user consents', errorText);
            const error = new Error(errorText);
            reject(error);
            queue.forEach(([, rej]) => {
              rej(error);
            });
            resetFetchQueue();
          })
        return;
      }
      result.json()
        .then((consents) => {
          grantedConsents = consents?.grantedAccess;
          pendingConsents = consents?.pendingAccess;
          resolve();
          queue.forEach(([res]) => res());
          resetFetchQueue();
        })
    })
    .catch((error) => {
      reject(error);
      queue.forEach(([, rej]) => {
        rej(error);
      });
      resetFetchQueue();
    })
});

export const addConsent = async (productId: string): Promise<void> => {
  const result = await fetch(`/api/consents?product=${productId}`, {
    method: 'POST',
  });
  if (!result.ok) {
    const error = await result.text();
    console.error('Could not save user consent', error);
    throw new Error(error);
  }
};

export const getConsents = async (): Promise<[ApiUserConsent[], ApiUserConsent[]]> => {
  if (!grantedConsents) {
    await fetchConsents();
  }

  return [grantedConsents, pendingConsents];
}


